import React, { useState } from 'react';
import { ArrowUpRight, Search, SlidersHorizontal } from 'lucide-react';
import { Action, Select } from '../ui';

const CatalogSearch = ({ query, onSearch }) => {
  const [text, setText] = useState(query);
  const submit = event => { event.preventDefault(); onSearch(text); };
  return <form onSubmit={submit} className="catalog-search">
    <Search size={17} /><input data-testid="catalog-search-input" aria-label="Search catalog"
      placeholder="Search by product, SKU, HSN or standard" value={text} onChange={event => setText(event.target.value)} />
    <button data-testid="catalog-search-submit" aria-label="Search catalog"><ArrowUpRight size={18} /></button>
  </form>;
};

export const CatalogToolbar = ({ query, sort, update, filtersOpen, toggleFilters }) => <div className="catalog-toolbar">
  <CatalogSearch key={query} query={query} onSearch={value => update('q', value)} />
  <Action id="toggle-catalog-filters" secondary className="filter-toggle" onClick={toggleFilters}
    aria-expanded={filtersOpen} aria-controls="catalog-filters"><SlidersHorizontal size={15} />Filters</Action>
  <Select id="catalog-sort" label="Sort by" value={sort} onChange={event => update('sort', event.target.value)}>
    <option value="featured">Featured</option><option value="name">Name A–Z</option><option value="moq">Lowest MOQ</option>
  </Select>
</div>;